import {
  DEFAULT_TRANSLATION_MOBILE,
  ITEM_MOBILE_FULL_WIDTH,
} from './constants';

export interface GetTranslationProps {
  toIndex: number;
}

export function getTranslationInPx({ toIndex }: GetTranslationProps): number {
  if (toIndex === 1) {
    return 0;
  }
  if (toIndex < 1) {
    return ITEM_MOBILE_FULL_WIDTH * (-toIndex + 1) + DEFAULT_TRANSLATION_MOBILE;
  }
  if (toIndex > 1) {
    return (
      -(ITEM_MOBILE_FULL_WIDTH * (toIndex - 1)) + DEFAULT_TRANSLATION_MOBILE
    );
  }
  return 0;
}
